import { ModelLibrary } from '../models/model-library';
import { ProjectXCompoundXModel } from '../models/project-x-compound-x-model';

export function enrichProjectXCompoundXModels(
  models: ProjectXCompoundXModel[] | undefined,
  modelLibrary: ModelLibrary[] | undefined,
): ProjectXCompoundXModel[] {
  if (!models?.length || !modelLibrary?.length) return models ?? [];

  const modelByPk = new Map<number, ModelLibrary>(
    modelLibrary.map((model: ModelLibrary) => [model.modelPk, model]),
  );

  return models.map((item: ProjectXCompoundXModel) => {
    const model = item.ModelPk ? modelByPk.get(item.ModelPk) : undefined;
    if (!model) return item;

    const modelAny = model as any;
    const modelVersion = model.version ?? modelAny.Version;
    const modelName = model.name ?? modelAny.Name;

    return {
      ...item,
      ModelName: item.ModelName ?? modelName,
      ModelVersion: item.ModelVersion ?? (modelVersion != null ? String(modelVersion) : undefined),
      CompartmentPk: item.CompartmentPk ?? model.compartmentXModel?.[0],
    };
  });
}